module.exports = __webpack_public_path__ + "static/media/3.ce9732a3.jpg";